import http from './http.service';

class RoleService {
    constructor() {
        this.$http = http;
        this.baseUrl = "/api/roles";
    }

    create(model) {
        if (!model) {
            throw new Error('Model is required');
        }

        return this.$http.post(`${this.baseUrl}/createRole`, model);
    }

    update(model) {
        if (!model) {
            throw new Error('Model is required');
        }

        return this.$http.put(`${this.baseUrl}/updateRole`, model);
    }

    activate(id) {
        if (!id) {
            throw new Error('Id is required');
        }

        return this.$http.delete(`${this.baseUrl}/activateRole`, { params: { id: id } });
    }

    deactivate(id) {
        if (!id) {
            throw new Error('Id is required');
        }

        return this.$http.delete(`${this.baseUrl}/deactivateRole`, { params: { id: id } });
    }

    delete(id) {
        if (!id) {
            throw new Error('Id is required');
        }

        return this.$http.delete(`${this.baseUrl}/deleteRole`, { params: { id: id } });
    }

}

export default new RoleService();
